import { Modal } from 'almanac-ui/Modal'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { RequestAnotherReviewContent } from './RequestAnotherReviewContent'

interface Props {
  request: InformalFeedbackRequest
}

export const RequestAnotherReviewModal = ({ request }: Props) => {
  return (
    <Modal.Root>
      <Modal.Header title="Request Another Review" />
      <RequestAnotherReviewContent request={request} />
    </Modal.Root>
  )
}
